import { defineMessages } from 'react-intl';

export default defineMessages({
    billingSummaryTabs: {
        id: 'billing.billing-summary-page.Billing Summary',
        defaultMessage: 'Billing Summary'
    },
    failedToLoadPolices: {
        id: 'billing.billing-summary.Failed to load polices',
        defaultMessage: 'Failed to load polices'
    },
    sorryWeCanNotLoadYourPolicyInformationAtThisTime: {
        id: 'billing.billing-summary.Sorry we can not load your policy information at this time',
        defaultMessage: 'Sorry we can not load your policy information at this time'
    },
    noBillingData: {
        id: 'billing.billing-summary.no billing data',
        defaultMessage: 'No Billing Data Available at this time'
    },
    upcomingPayments: {
        id: 'portal.views.home-page-layout.Upcoming Payments New',
        defaultMessage: 'Upcoming Payments - Policies highlighted in red are past due and require your immediate attention.',
    },
    billingpolicyNumber: {
        id: 'policy.common.directives.templates.billing-details.policyNumber',
        defaultMessage: 'Policy Number',
    },
    billingDetailsAmount: {
        id: 'policy.common.directives.templates.billing-details.Amount',
        defaultMessage: 'Amount',
    },
    billingDetailsDueDate: {
        id: 'policy.common.directives.templates.billing-details.Payment Date',
        defaultMessage: 'Payment Date',
    },
    billingDetailsPaymentSchedule: {
        id: 'portal.views.home-page-layout.Payment Schedule',
        defaultMessage: 'Payment Schedule',
    },
    noUpcomingPayments: {
        id: 'portal.views.home-page-layout.There are no Upcoming Payments for your PoliciesAccount',
        defaultMessage: 'There are no upcoming payments for your Policies/Account',
    },
    noPaymentSchedules: {
        id: 'portal.views.home-page-layout.There are no payment schedules for your PoliciesAccount',
        defaultMessage: 'There are no payment schedules for your Policies/Account',
    },
    billingHeaderMsg: {
        id: 'portal.views.home-page-layout.billingHeaderMessage',
        defaultMessage: 'Only payments made directly to Heartland Farm Mutual Inc. are displayed. For any payments made to your broker, please contact your broker.',
    }
});
